import { z } from 'zod'

import { HOUSEHOLD_STEPS, validationTranslationParams } from '@flows/configs/householdAt/constants'
import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import { t } from '@flows/core/i18n'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_HouseholdV1GetsafeAt } from '@flows/insurance/schemas'

const getErrorMap = (): z.ZodErrorMap => (issue, ctx) => {
  switch (issue.code) {
    case z.ZodIssueCode.too_small:
      return {
        message: t('sharedFlows_householdAt:steps.square_meters.input.error.min', {
          min: issue.minimum,
        }),
      }
    case z.ZodIssueCode.too_big:
      return {
        message: t('sharedFlows_householdAt:steps.square_meters.input.error.max', {
          max: issue.maximum,
        }),
      }
    default:
      return { message: ctx.defaultError }
  }
}

const household_at_square_meters = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('square_meters')]:
        BaseSchema_HouseholdV1GetsafeAt.shape.square_meters,
    }),
    errorMap: getErrorMap(),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_householdAt:steps.square_meters.title',
        },
      },
      {
        type: 'input',
        shouldTrackValues: true,
        inputType: 'integer',
        name: params.helperFunctions.getParamPath('square_meters'),
        label: {
          type: 'translatableText',
          translationKey: 'sharedFlows_householdAt:steps.square_meters.input.label',
        },
      },
      {
        type: 'infoBox',
        showInfoIcon: true,
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_householdAt:steps.square_meters.info',
          values: validationTranslationParams.square_meters,
        },
      },
    ],
    subFlow: params.subFlow,
    nextStep: HOUSEHOLD_STEPS.household_at_furnishing_level,
  }) as const satisfies AnyStepConfiguration

export default household_at_square_meters
